import { Auth0SecuredApp } from './Auth0SecureApp'
import { useEffect } from 'react'
import { useTenantPartnerId } from '../utils/Hooks/usePartnerData'
import { useAuth0 } from '@auth0/auth0-react'
import { useSelector } from '../../store'

const OktaAndAuth0SecureApp = () => {
  const partnerId = useTenantPartnerId()
  const { user } = useAuth0()

  const idpUserId = useSelector<string | undefined>(
    state => state.userProfile?.userProfile?.idpUserId
  )

  const userRoles = useSelector<string[] | undefined>(
    state => state.userProfile?.userProfile?.roles
  )

  useEffect(() => {
    if (partnerId && typeof window !== 'undefined' && window.newrelic) {
      // Set unique user ID (shows as enduser.id in New Relic)
      if (window.newrelic.setUserId) {
        const uniqueUserId = user?.partner_user_id
        window.newrelic.setUserId(uniqueUserId)
      }

      // Set partner ID, auth0Id, and roles as custom attributes for filtering/grouping
      if (window.newrelic.setCustomAttribute) {
        window.newrelic.setCustomAttribute('partnerId', partnerId)
        window.newrelic.setCustomAttribute('idpUserId', idpUserId || '')

        const roles = userRoles || user?.auth0_roles || []
        window.newrelic.setCustomAttribute('userRoles', roles.join(','))
      }
    }
  }, [partnerId, user, idpUserId, userRoles])

  return <Auth0SecuredApp />
}

export default OktaAndAuth0SecureApp
